module.exports = __webpack_public_path__ + "static/building_frame_night-3ae5b02633816dcd86b9d95d97b1ac14.jpg";